import { render, staticRenderFns } from "./sunhaoTable.vue?vue&type=template&id=715451e4&scoped=true&"
import script from "./sunhaoTable.vue?vue&type=script&lang=js&"
export * from "./sunhaoTable.vue?vue&type=script&lang=js&"
import style1 from "./sunhaoTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715451e4",
  null
  
)

export default component.exports